import { useRef } from 'react';

import useUploadForm from 'app/hooks/useUploadForm';

import {
  ACCESS_CODE_PAGE_LOGO_UPLOAD_URL
} from 'app/utils/Constants';

import {
  updateAccessCodePage
} from 'app/services/accessCodePages';

const useAccessCodePageLogoUploadForm = props => {
  const {
    accessCodePage,
    onUploadStart,
    onUploadComplete
  } = props;

  const fileTypeRef = useRef();

  const createFileContexts = async params => {
    // the original file objects shouldn't be altered
    const file = params.files[0];
    fileTypeRef.current = file.type;

    let fileContexts = [{
      id: accessCodePage.id + '-logo',
      uploadUrlEndpoint: ACCESS_CODE_PAGE_LOGO_UPLOAD_URL(accessCodePage.id, file.type)
    }]

    if (onUploadStart) {
      onUploadStart(file);
    }

    return fileContexts;
  }

  const onFileComplete = async () => {
    await updateAccessCodePage(accessCodePage.id, { logo_mime_type: fileTypeRef.current });

    if (onUploadComplete) {
      onUploadComplete();
    }
  }

  const {
    formIsOpen,
    onFormClose,
    onFormSubmit,
    onAdd,
  } = useUploadForm({
    createFileContexts,
    onFileComplete
  });

  return {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  }
}

export default useAccessCodePageLogoUploadForm;
